import { Empty } from 'antd';
import styled, { css } from 'styled-components';

export const StyledIcon = styled.div<{ $showDot?: boolean }>`
  position: relative;
  cursor: pointer;
  ${({ $showDot }) =>
    $showDot &&
    css`
      &::after {
        position: absolute;
        content: '';
        right: 0;
        top: 0;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: #eb5757;
      }
    `}
`;

export const StyledContainer = styled.div`
  width: 440px;
  max-width: 100vw;
  padding: 0 16px;
`;

export const StyledContent = styled.div`
  box-shadow: 0px 4px 20px 0px #e7eaf6;
  margin-top: 20px;
  background-color: #ffffff;
  border-radius: 8px;
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eff3ff;
`;

export const TabItem = styled.button<{ selected: boolean }>`
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? '#EFF3FF' : 'transparent')};
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
`;

export const SectionTitle = styled.span`
  font-size: 16px;
  color: #6b7083;
  font-weight: bold;
  padding-left: 16px;
  padding-top: 12px;
`;

export const StyledEmpty = styled(Empty)`
  padding: 64px 0;
  .ant-empty-image {
    margin-bottom: 16px;
  }
  .ant-empty-description {
    color: #0b1a30;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.43;
    max-width: 200px;
    margin: 0 auto;
    text-align: center;
  }
`;

export const StyledList = styled.div`
  overflow-y: scroll;
  max-height: 100%;
  max-height: calc(100vh - 165px);
  min-height: 325px;
`;
